import React, { useState, useEffect, useContext } from "react";
import { API_URL } from "../../components/api";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridFooterContainer,
  GridPagination,
} from "@mui/x-data-grid";
import ExcelSVG from "./ExcelSVG.svg";
import FilterSVG from "./FilterSVG.svg";
import * as XLSX from "xlsx";
import Modal from "react-bootstrap/Modal";
import AuthContext from "../../context/AuthContext";
import LanguageContext from "../../context/LanguageContext";
import axios from "axios";
import Collect from "./collect";
import { formatAmount } from "../../../utils/money";
import Statement from "./statement";
import Discounts from "./discounts";
import MainComponent from "./clientPayment";
import Receipt from "./receipt";
import OfferForm from "./offers";

import Note from "./notes";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import MenuList from "@mui/material/MenuList";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHandHoldingDollar } from "@fortawesome/free-solid-svg-icons";
import "./accountingtb.css";
import Typography from "@mui/material/Typography";

function Accountingtb({ walletOnly = false }) {
  const { user } = useContext(AuthContext);
  const { language, direction, t } = useContext(LanguageContext);

  const [data, setData] = useState([]);

  const [showReceipt, setShowReceipt] = useState(false);
  const [receiptData, setReceiptData] = useState(null);

  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [Client, setClient] = useState("");
  const [show, setShow] = useState(false);
  const [showNotes, setShowNotes] = useState(false);
  const [showDiscounts, setShowDiscounts] = useState(false);
  const [showStatement, setShowStatement] = useState(false);
  const [shift, setShift] = useState(false); // Changed to boolean type
  const [permanent, setPermanent] = useState("");
  const [temporary, setTemporary] = useState("");
  const [balance, setBalance] = useState("");
  const [fullName, setfullName] = useState("");

  const receiptClose = () => {
    setShowReceipt(false);
    setReceiptData(null);
  };
  const receiptShow = (data) => {
    setReceiptData(data);
    setShowReceipt(true);
  };

  const DiscountClose = () => setShowDiscounts(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedActionRow, setSelectedActionRow] = useState(null);

  const CloseCollect = () => setShow(false);
  const ShowCollect = (event) => setAnchorEl(event.currentTarget);
  const CloseNotes = () => setShowNotes(false);
  const CloseStatement = () => setShowStatement(false);

  const ShowNotes = (event) => setAnchorEl(event.currentTarget);
  const [showOffer, setShowOffer] = useState(false);

  const CloseOffer = () => setShowOffer(false);

  const [ClientDetails, setClientDetails] = useState({
    username: "",
    password: 0,
    subId: 0,
    intSubId: 0,
    intPlanId: 0,
    site: "",
    planName: "",
    fullName: "",
    expDate: "",
    consumption: "",
    connectivity: "",
    due: "",
  });
  const [filters, setFilters] = useState({
    fullname_en: "",
    phone_number: "",
    client_notes: "",
    discounts: "",
    balance_notes: "",
    village_name: "",
    address_string: "",
    balance_usd: "",
    employee_en: "",
  });
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [gridFilterModel, setGridFilterModel] = useState({
    items: [],
  });
  const [searchInput, setSearchInput] = useState(""); // To capture search input

  // NEW: State to track column visibility
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
  const [searchFilterTimeout, setSearchFilterTimeout] = useState(null);

  const fetchData = async () => {
    try {
      const authTokens = JSON.parse(localStorage.getItem("authTokens"));
      const clientsUrl = walletOnly
        ? `${API_URL}/accounting/collectors/clients/`
        : `${API_URL}/accounting/info/`;
      if (language === "ar") {
        const response = await axios.get(clientsUrl, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
            lang: "ar",
          },
        });

        if (response.status === 200) {
          setData(response.data);
          console.log(response.data);
        }

        return;
      }

      const response = await axios.get(clientsUrl, {
        headers: {
          Authorization: `Bearer ${authTokens.access}`,
        },
        params: {
          username: user.username,
        },
      });

      if (response.status === 200) {
        setData(response.data);
        console.log(response.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const fetchShift = async () => {
    try {
      const authTokens = JSON.parse(localStorage.getItem("authTokens"));
      const response = await axios.get(`${API_URL}/inventory/shift/status/`, {
        headers: {
          Authorization: `Bearer ${authTokens.access}`,
        },
        params: {
          username: user.username,
        },
      });

      if (response.status === 200) {
        setShift(response.data); // Assuming response.data is boolean
        console.log(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchShift();
    fetchData();
  }, [user.username]);

  const previousLanguageRef = React.useRef(language);

  useEffect(() => {
    if (previousLanguageRef.current === language) {
      return;
    }

    previousLanguageRef.current = language;
    fetchData();
  }, [language]);


  const collectionLocaleText = language === "ar" ? {
    toolbarColumns: t("collection.columns"),
    toolbarExport: t("collection.export"),
    toolbarExportCSV: t("collection.exportCsv"),
    toolbarExportPrint: t("collection.print"),
    footerRowSelected: (count) =>
      t("collection.selectedRows", { count }),
    MuiTablePagination: {
      labelRowsPerPage: t("collection.rowsPerPage"),
      labelDisplayedRows: ({ from, to, count }) =>
        t("collection.pageRange", {
          from,
          to,
          count: count !== -1 ? count : `>${to}`,
        }),
    },
  } : undefined;

  const columns = [
    {
      field: "actions",
      headerName: t("collection.actions"),
      ...(direction === "rtl"
        ? { width: 110, minWidth: 110, align: "center", headerAlign: "center" }
        : {}),
      renderCell: (params) => (
        <div className="collection-action-cell">
          {(!walletOnly || shift) && (
            <Button
              variant="contained"
              onClick={(event) => {
                if (walletOnly) {
                  setSelectedActionRow(params.row);
                  setClient(params.row.client_id);
                  setfullName(params.row.fullname_en);
                  setBalance(params.row.balance_usd);
                  setTemporary(params.row.client_notes);
                  setPermanent(params.row.balance_notes);
                  setShow(true);
                  setAnchorEl(null);
                  return;
                }

                ShowCollect(event);
                setSelectedActionRow(params.row);
                setClient(params.row.client_id);
                setfullName(params.row.fullname_en);
                setBalance(params.row.balance_usd);
                setTemporary(params.row.client_notes);
                setPermanent(params.row.balance_notes);
              }}
              style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
            >
              <FontAwesomeIcon icon={faHandHoldingDollar} />
            </Button>
          )}
        </div>
      ),
    },

    {
      field: "fullname_en",
      headerName: t("collection.fullName"),
      flex: 2,
      minWidth: 250,
    },
    {
      field: "phone_number",
      headerName: t("collection.phoneNumber"),
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        // Check if phone number length is 7, then add '0' at the beginning
        let phone = params.row.phone_number;
        if (phone && phone.length === 7) {
          phone = "0" + phone; // Concatenate '0' to the phone number
        }
        return <span>{phone}</span>;
      },
    },
    {
      field: "balance_usd",
      headerName: t("collection.balance"),
      flex: 1,
      minWidth: 150,
      renderCell: (params) => formatAmount(params.value, 2),
    },
    {
      field: "discounts",
      headerName: t("collection.discounts"),
      flex: 1,
      minWidth: 150,
      renderCell: (params) => formatAmount(params.value),
    },
    {
      field: "balance_notes",
      headerName: t("collection.paymentNotes"),
      flex: 1,
      minWidth: 150,
    },
    ...(walletOnly
      ? [
          {
            field: "payment_date",
            headerName:
              language === "ar"
                ? "\u062a\u0627\u0631\u064a\u062e \u0627\u0644\u062f\u0641\u0639"
                : "Payment Date",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => {
              const value = params.row.payment_date;
              if (!value) return "-";
              const datePart = String(value).split("T")[0];
              const parts = datePart.split("-");
              return parts.length === 3
                ? [parts[2], parts[1], parts[0]].join("/")
                : String(value);
            },
          },
        ]
      : []),
    {
      field: "village_name",
      headerName: t("collection.villageName"),
      flex: 1,
      minWidth: 150,
    },
    { field: "address_string", headerName: t("collection.address"), flex: 1, minWidth: 250 },
    {
      field: "client_notes",
      headerName: t("collection.clientNotes"),
      flex: 1,
      minWidth: 150,
    },
    { field: "employee_en", headerName: t("collection.collector"), flex: 1, minWidth: 150 },
  ];

  const displayColumns =
    language === "ar"
      ? columns.map((column) =>
          column.field === "fullname_en"
            ? {
                ...column,
                field: "fullname_ar",
              }
            : column
        )
      : columns;

  const getRowId = (row) => row.client_id;

  // Create a delayed search filter function
  const delaySearchFilter = (input) => {
    setSearchQuery(input);
  };

  useEffect(() => {
    // Save "searchValue" value before clearing other session storage items
    const searchValue = sessionStorage.getItem("searchCollection");

    // Clear all session storage items except "searchValue"
    Object.keys(sessionStorage).forEach((key) => {
      if (key !== "searchCollection") {
        sessionStorage.removeItem(key);
      }
    });

    // Restore "searchValue" value if needed
    if (searchValue) {
      sessionStorage.setItem("searchCollection", searchValue);
      setSearchQuery(searchValue);
      setSearchInput(searchValue);
    }
  }, []);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchInput(query);
    sessionStorage.setItem("searchCollection", query);

    if (searchFilterTimeout) {
      clearTimeout(searchFilterTimeout);
    }

    const newTimeout = setTimeout(() => {
      delaySearchFilter(query);
    }, 300);
    setSearchFilterTimeout(newTimeout);
  };

  // IMPROVED: Combined filtering logic that works for both display AND export
  const filteredRows = data.filter((row) => {
    // Apply search query filter
    const searchMatch = searchQuery
      .split(" ")
      .every((word) =>
        Object.values(row).some((value) =>
          String(value).toLowerCase().includes(word.toLowerCase().trim())
        )
      );

    // Apply modal filters
    const modalFilterMatch = Object.keys(filters).every((key) => {
      if (!filters[key]) return true;

      const rowValue = String(row[key] || "").toLowerCase();
      const filterValue = String(filters[key]).toLowerCase();
      return rowValue.includes(filterValue);
    });

    // Apply DataGrid filters
    const gridFilterMatch = gridFilterModel.items.every((filterItem) => {
      if (!filterItem.value) return true;

      const cellValue = row[filterItem.field];
      const filterValue = filterItem.value;

      switch (filterItem.operator) {
        case "contains":
          return String(cellValue || "")
            .toLowerCase()
            .includes(String(filterValue).toLowerCase());
        case "equals":
          return String(cellValue || "") === String(filterValue);
        case "startsWith":
          return String(cellValue || "")
            .toLowerCase()
            .startsWith(String(filterValue).toLowerCase());
        case "endsWith":
          return String(cellValue || "")
            .toLowerCase()
            .endsWith(String(filterValue).toLowerCase());
        default:
          return true;
      }
    });

    return searchMatch && modalFilterMatch && gridFilterMatch;
  });

  const arabicFilteredRows = data.filter((row) => {
    const rowForArabicSearch = {
      ...row,
      fullname_en: row.fullname_ar || "",
    };

    const searchMatch = searchQuery
      .split(" ")
      .every((word) =>
        Object.values(rowForArabicSearch).some((value) =>
          String(value)
            .toLowerCase()
            .includes(word.toLowerCase().trim())
        )
      );

    const modalFilterMatch = Object.keys(filters).every((key) => {
      if (!filters[key]) return true;

      const rowValue = String(
        rowForArabicSearch[key] || ""
      ).toLowerCase();

      const filterValue = String(
        filters[key]
      ).toLowerCase();

      return rowValue.includes(filterValue);
    });

    const gridFilterMatch = gridFilterModel.items.every(
      (filterItem) => {
        if (!filterItem.value) return true;

        const cellValue =
          rowForArabicSearch[filterItem.field];

        const filterValue = filterItem.value;

        switch (filterItem.operator) {
          case "contains":
            return String(cellValue || "")
              .toLowerCase()
              .includes(
                String(filterValue).toLowerCase()
              );

          case "equals":
            return (
              String(cellValue || "")
              === String(filterValue)
            );

          case "startsWith":
            return String(cellValue || "")
              .toLowerCase()
              .startsWith(
                String(filterValue).toLowerCase()
              );

          case "endsWith":
            return String(cellValue || "")
              .toLowerCase()
              .endsWith(
                String(filterValue).toLowerCase()
              );

          default:
            return true;
        }
      }
    );

    return (
      searchMatch
      && modalFilterMatch
      && gridFilterMatch
    );
  });

  const displayRows =
    language === "ar"
      ? arabicFilteredRows
      : filteredRows;

  const handleFilterChange = (field, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [field]: value,
    }));
  };

  const columnHeaders = {
    fullname_en: t("collection.fullName"),
    phone_number: t("collection.phoneNumber"),
    client_notes: t("collection.clientNotes"),
    discounts: t("collection.discounts"),
    balance_notes: t("collection.paymentNotes"),
    village_name: t("collection.villageName"),
    address_string: t("collection.address"),
    balance_usd: t("collection.balance"),
    employee_en: t("collection.collector"),
  };

  // Corrected: Transform rows respecting column visibility
  const transformRowsForExport = (rows) => {
    return rows.map((row) => {
      const transformedRow = {};

      Object.keys(columnHeaders).forEach((field) => {
        // Only export if column is visible
        if (columnVisibilityModel[field] !== false) {
          const headerName = columnHeaders[field];
          transformedRow[headerName] = row[field] ?? "";
        }
      });

      return transformedRow;
    });
  };
  // IMPROVED: Export function that uses the already-filtered rows
  const handleExportToExcel = () => {
    console.log("Exporting data...");
    console.log("Total data rows:", data.length);
    console.log("Filtered rows:", filteredRows.length);
    console.log("Active filters:", {
      search: searchQuery,
      modalFilters: filters,
      gridFilters: gridFilterModel.items,
    });
    console.log("Column visibility:", columnVisibilityModel);

    // Always use filteredRows which has ALL filters applied
    const transformedRows = transformRowsForExport(filteredRows);

    console.log("Rows to export:", transformedRows.length);

    const worksheet = XLSX.utils.json_to_sheet(transformedRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, t("collection.collectionSheet"));
    XLSX.writeFile(workbook, t("collection.collectionFile"));
  };

  const [isPressed, setIsPressed] = useState(false);

  const handleExportClick = () => {
    setIsPressed(true);
    handleExportToExcel();
    setTimeout(() => {
      setIsPressed(false);
    }, 200);
  };

  const CustomToolbar = () => (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <Button
        onClick={() => setShowFilterModal(true)}
        style={{
          display: "flex",
          alignItems: "center",
          padding: "5px 10px",
          fontSize: "14px",
          color: "#0663FF",
          cursor: "pointer",
          marginLeft: "8px",
        }}
      >
        <img
          src={FilterSVG}
          alt="Filter Icon"
          style={{
            color: "white",
            width: "18px",
            marginRight: "8px",
            filter: "invert(0)", // keep black icon
          }}
        />
        {t("collection.filter")}
      </Button>
      {/*<GridToolbarFilterButton />*/}
      <GridToolbarExport />
      <Button
        onClick={handleExportClick}
        variant="outline-success"
        style={{
          display: "flex",
          alignItems: "center",
          padding: "5px 10px",
          fontSize: "14px",
          border: "none",
          backgroundColor: isPressed ? "white" : "transparent",
          color: isPressed ? "black" : "#007bff",
          cursor: "pointer",
        }}
      >
        <img
          src={ExcelSVG}
          alt="Excel Icon"
          style={{
            width: "20px",
            marginRight: "8px",
            filter: isPressed ? "invert(0)" : "invert(1)",
          }}
        />
        {t("collection.excel")}
      </Button>
    </GridToolbarContainer>
  );

  const CustomFooter = ({ selectedCount }) => {
    return (
      <GridFooterContainer
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <GridPagination />
      </GridFooterContainer>
    );
  };
  const actionMenuItems = (
    <>
      {shift && (
        <MenuItem
          onClick={() => {
            if (selectedActionRow) {
              setClient(selectedActionRow.client_id);
              setBalance(selectedActionRow.balance_usd);
              setfullName(selectedActionRow.fullname_en);
              setTemporary(selectedActionRow.client_notes);
              setPermanent(selectedActionRow.balance_notes);
            }
            setShow(true);
            setAnchorEl(null);
          }}
        >
          {t("collection.wallet")}
        </MenuItem>
      )}
      <MenuItem
        onClick={() => {
          if (selectedActionRow) {
            setClient(selectedActionRow.client_id);
            setTemporary(selectedActionRow.client_notes);
            setPermanent(selectedActionRow.balance_notes);
          }
          setShowNotes(true);
          setAnchorEl(null);
        }}
      >
        {t("collection.notes")}
      </MenuItem>
      <MenuItem
        onClick={() => {
          if (selectedActionRow) {
            setClient(selectedActionRow.client_id);
            setBalance(selectedActionRow.balance_usd);
            setfullName(selectedActionRow.fullname_en);
          }
          setShowStatement(true);
          setAnchorEl(null);
        }}
      >
        {t("collection.statement")}
      </MenuItem>
      <MenuItem
        onClick={() => {
          if (selectedActionRow) {
            setClient(selectedActionRow.client_id);
            setBalance(selectedActionRow.balance_usd);
            setfullName(selectedActionRow.fullname_en);
          }
          setShowDiscounts(true);
          setAnchorEl(null);
        }}
      >
        {t("collection.discount")}
      </MenuItem>
      <MenuItem
        onClick={() => {
          setShowOffer(true);
          setAnchorEl(null);
        }}
      >
        {t("collection.offer")}
      </MenuItem>
    </>
  );

  return (
    <div className="ClientTable" dir={direction}>
      <style>{`
        .MuiDataGrid-panelWrapper {
          background: #122632 !important;
        }
      `}</style>
      <div className="actions">
        <input
          type="text"
          placeholder={t("collection.searchPlaceholder")}
          value={searchInput}
          onChange={handleSearchChange}
          className="search-accounting"
        />
      </div>
      {!loading && data.length > 0 && (
        <div
          className={
            language === "ar"
              ? "collection-arabic-grid-scroll"
              : undefined
          }
          style={{ height: "100vh", width: "100%" }}
        >
          <DataGrid
            localeText={collectionLocaleText}
            rows={displayRows}
            columns={displayColumns}
            getRowId={getRowId}
            filterModel={gridFilterModel}
            onFilterModelChange={(newModel) => setGridFilterModel(newModel)}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) =>
              setColumnVisibilityModel(newModel)
            }
            components={{
              Footer: () => <CustomFooter />,
              Toolbar: CustomToolbar,
            }}
            rowsPerPageOptions={[10, 100, 1000]}
            pagination
            disableSelectionOnClick
          />
        </div>
      )}
      {direction === "rtl" ? (
        <Popper
          id="collection-actions-menu"
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          placement="bottom-end"
          popperOptions={{ strategy: "fixed" }}
          modifiers={[
            {
              name: "flip",
              enabled: true,
            },
            {
              name: "preventOverflow",
              enabled: true,
              options: { padding: 8 },
            },
          ]}
          style={{ zIndex: 10001 }}
        >
          <ClickAwayListener
            onClickAway={() => {
              setAnchorEl(null);
              setSelectedActionRow(null);
            }}
          >
            <Paper
              sx={{
                direction: "rtl",
                minWidth: 180,
                maxWidth: 180,
                maxHeight: 300,
                overflowY: "auto",
                color:
                  "var(--accounting-modal-header-text, #ffffff)",
                background:
                  "var(--accounting-panel-bg, #122632)",
                border: "1px solid #294455",
                borderRadius: "6px",
                boxShadow:
                  "0 8px 24px rgba(0, 0, 0, 0.4)",
              }}
            >
              <MenuList dir="rtl">
                {actionMenuItems}
              </MenuList>
            </Paper>
          </ClickAwayListener>
        </Popper>
      ) : (
          <Menu
            id="collection-actions-menu"
            sx={
              direction === "rtl"
                ? {
                    position: "fixed !important",
                    top: "0 !important",
                    right: "0 !important",
                    bottom: "0 !important",
                    left: "0 !important",
                    width: "100vw !important",
                    height: "100vh !important",
                  }
                : undefined
            }
            anchorEl={anchorEl}
            anchorReference={direction === "rtl" ? "anchorPosition" : "anchorEl"}
            anchorPosition={
              direction === "rtl" && anchorEl
                ? {
                    top: anchorEl.getBoundingClientRect().bottom,
                    left: anchorEl.getBoundingClientRect().right,
                  }
                : undefined
            }
            marginThreshold={16}
            open={Boolean(anchorEl)}
            onClose={() => {
              setAnchorEl(null);
              setSelectedActionRow(null);
            }}
            disableScrollLock={direction === "rtl"}
            anchorOrigin={direction === "rtl"
              ? { vertical: "bottom", horizontal: "right" }
              : undefined}
            transformOrigin={direction === "rtl"
              ? { vertical: "top", horizontal: "right" }
              : undefined}
            MenuListProps={{ dir: direction }}
            PaperProps={{
              sx: {
                direction,
                borderRadius: "6px",
                marginTop: "20px",
                minWidth: 180,
                maxWidth: 180,
                maxHeight: "300px",
                overflowY: "auto",
                scrollbarWidth: "thin", // Firefox
                "&::-webkit-scrollbar": {
                  width: "6px",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#aaa",
                  borderRadius: "10px",
                },
              },
            }}
          >
            {actionMenuItems}
          </Menu>
      )}

      <Modal show={show} onHide={CloseCollect} className="accounting-wallet-modal">
        <div className="forma">
          <Modal.Header closeButton>
            <Modal.Title>{t("collection.wallet")}</Modal.Title>
          </Modal.Header>
          <Collect
            client_id={Client}
            balance_usd={balance}
            fullName={fullName}
            handleClose={CloseCollect}
            handleOpen={receiptShow}
            fetch={fetchData}
            freeCollection={Boolean(walletOnly)}
          />
        </div>
      </Modal>
      <Modal show={showNotes} onHide={CloseNotes}>
        <div className="forma">
          <Modal.Header closeButton>
            <Modal.Title>{t("collection.addNotes")}</Modal.Title>
          </Modal.Header>
          <Note
            client_id={Client}
            balance_notes={temporary}
            client_notes={permanent}
          />
        </div>
      </Modal>
      {/* Statement Modal - Full Screen */}
      <Modal
        show={showStatement}
        onHide={CloseStatement}
        dialogClassName="modal-fullscreen"
        style={{
          maxWidth: "100vw",
          width: "100vw",
          height: "100vh",
          margin: 0,
        }}
      >
        <div
          className="forma"
          style={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <Modal.Header
            closeButton
            style={{
              flexShrink: 0,
              backgroundColor: "rgb(18, 38, 50)",
              color: "#f5ffff",
              borderBottom: "2px solid rgba(255, 255, 255, 0.1)",
            }}
          >
            <Modal.Title>{t("collection.statementOfAccount")}</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              flex: 1,
              overflow: "auto",
              padding: 0,
            }}
          >
            <Statement
              client_id={Client}
              balance_usd={balance}
              fullName={fullName}
              onClose={() => setShowStatement(false)}
            />
          </Modal.Body>
        </div>
      </Modal>

      <Modal show={showReceipt} onHide={receiptClose}>
        <div className="receipt-modal">
          <Modal.Header closeButton>
            <Modal.Title>{t("collection.receipt")}</Modal.Title>
          </Modal.Header>
          <Receipt
            client_id={Client}
            data={receiptData}
            close={receiptClose}
          />
        </div>
      </Modal>
        <Modal
          show={showDiscounts}
          onHide={DiscountClose}
          className="modal-lg accounting-discount-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>{t("collection.discounts")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Discounts
              client_id={Client}
              fullName={fullName}
              close={DiscountClose}
            />
          </Modal.Body>
        </Modal>
        <Modal show={showOffer} onHide={CloseOffer} className="modal-lg accounting-offer-modal">
        <div className="receipt-modal">
          <Modal.Header closeButton>
            <Modal.Title>{t("collection.addOffer")}</Modal.Title>
          </Modal.Header>
          <OfferForm client_id={Client} close={CloseOffer} />
        </div>
      </Modal>
      <Modal show={showFilterModal} onHide={() => setShowFilterModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{t("collection.filters")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {columns
            .filter((col) => col.field !== "actions")
            .map((col) => (
              <div key={col.field} className="filter">
                <label>{col.headerName}</label>
                <input
                  type="text"
                  placeholder={t("collection.filterBy", { column: col.headerName })}
                  value={filters[col.field] || ""}
                  onChange={(e) =>
                    handleFilterChange(col.field, e.target.value)
                  }
                  className="filter-input"
                />
              </div>
            ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowFilterModal(false)}>
            {t("collection.close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Accountingtb;
